import { formatDate as fmtDate } from '../../utils/formatDate';

export const formatDate = fmtDate;

export function formatDateTime(d) {
  if (!d) return '-';
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return '-';
  return dt.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function getToday() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function getDateNDaysAgo(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function formatCpf(val) {
  if (!val) return '-';
  const s = String(val).replace(/\D/g, '').padStart(11, '0');
  return s.length === 11 ? `${s.slice(0,3)}.${s.slice(3,6)}.${s.slice(6,9)}-${s.slice(9)}` : val;
}

export function formatTime(val) {
  if (!val) return '-';
  const s = String(val);
  // "1970-01-01T07:30:00.000Z" or "07:30:00" or datetime
  const m = s.match(/(\d{2}):(\d{2})/);
  return m ? `${m[1]}:${m[2]}` : '-';
}

export const TIPO_ATENDIMENTO_MAP = {
  '01': '01 - Remoção', '02': '02 - Pequena Cirurgia', '03': '03 - Outras Terapias',
  '04': '04 - Consulta', '08': '08 - Quimioterapia', '09': '09 - Radioterapia',
  '10': '10 - TRS', '13': '13 - Pequeno Atendimento', '23': '23 - Exame',
};

export function formatTipoAtendimento(val) {
  if (!val) return '-';
  const key = String(val).padStart(2, '0');
  if (TIPO_ATENDIMENTO_MAP[key]) return TIPO_ATENDIMENTO_MAP[key];
  // Valor invalido no TISS - sistema envia 23 (Exame)
  return `${val} (invalido, sistema envia 23 - Exame)`;
}

export function formatDuration(ms) {
  if (!ms && ms !== 0) return '-';
  if (ms < 1000) return `${ms}ms`;
  return `${(ms / 1000).toFixed(1)}s`;
}

export function formatXml(xml) {
  if (!xml) return '';
  let formatted = '';
  let indent = 0;
  const parts = xml.replace(/>\s*</g, '><').split(/(<[^>]+>)/g).filter(Boolean);
  for (const part of parts) {
    if (part.startsWith('</')) {
      indent = Math.max(0, indent - 1);
      formatted += '  '.repeat(indent) + part + '\n';
    } else if (part.startsWith('<') && part.endsWith('/>')) {
      formatted += '  '.repeat(indent) + part + '\n';
    } else if (part.startsWith('<?')) {
      formatted += part + '\n';
    } else if (part.startsWith('<') && !part.startsWith('</')) {
      formatted += '  '.repeat(indent) + part + '\n';
      if (!part.endsWith('/>')) indent++;
    } else {
      formatted = formatted.trimEnd() + part + '\n';
    }
  }
  return formatted.trim();
}

export function parseXmlTag(xml, tag) {
  if (!xml) return '';
  const re = new RegExp(`<(?:ans:)?${tag}[^>]*>([^<]*)<`, 'i');
  const m = xml.match(re);
  return m ? m[1].trim() : '';
}

export function parseXmlProcedimentos(xml) {
  if (!xml) return [];
  const procs = [];
  const re = /<(?:ans:)?procedimentosSolicitados>([\s\S]*?)<\/(?:ans:)?procedimentosSolicitados>/gi;
  let m;
  while ((m = re.exec(xml)) !== null) {
    const bloco = m[1];
    procs.push({
      codigo: parseXmlTag(bloco, 'codigoProcedimento'),
      descricao: parseXmlTag(bloco, 'descricaoProcedimento'),
      tabela: parseXmlTag(bloco, 'codigoTabela'),
      quantidade: parseXmlTag(bloco, 'quantidadeSolicitada') || '1',
    });
  }
  return procs;
}

export function parseXmlGlosas(xml) {
  if (!xml) return [];
  const glosas = [];
  const re = /<(?:ans:)?mensagemErro>([\s\S]*?)<\/(?:ans:)?mensagemErro>/gi;
  let m;
  while ((m = re.exec(xml)) !== null) {
    glosas.push({
      codigo: parseXmlTag(m[1], 'codigoGlosa'),
      descricao: parseXmlTag(m[1], 'descricaoGlosa'),
    });
  }
  return glosas;
}

export function parseElegibilidadeData(xmlReq, xmlResp) {
  const data = {
    carteirinha: parseXmlTag(xmlReq, 'numeroCarteira') || parseXmlTag(xmlResp, 'numeroCarteira'),
    prestador: parseXmlTag(xmlReq, 'codigoPrestadorNaOperadora'),
    nomeBeneficiario: parseXmlTag(xmlResp, 'nomeBeneficiario'),
    elegivel: parseXmlTag(xmlResp, 'respostaSolicitacao') === 'S',
    respostaCodigo: parseXmlTag(xmlResp, 'respostaSolicitacao'),
    motivos: [],
  };
  if (xmlResp) {
    const re = /<(?:ans:)?motivoNegativa>([\s\S]*?)<\/(?:ans:)?motivoNegativa>/gi;
    let m;
    while ((m = re.exec(xmlResp)) !== null) {
      data.motivos.push({
        codigo: parseXmlTag(m[1], 'codigoGlosa'),
        descricao: parseXmlTag(m[1], 'descricaoGlosa'),
      });
    }
  }
  return data;
}

export function parseSolicitacaoData(xmlReq, xmlResp) {
  const data = {
    carteirinha: parseXmlTag(xmlReq, 'numeroCarteira') || parseXmlTag(xmlResp, 'numeroCarteira'),
    nomeBeneficiario: parseXmlTag(xmlResp, 'nomeBeneficiario'),
    numeroGuiaOperadora: parseXmlTag(xmlResp, 'numeroGuiaOperadora'),
    numeroProtocolo: parseXmlTag(xmlResp, 'numeroProtocolo'),
    respostaSolicitacao: parseXmlTag(xmlResp, 'respostaSolicitacao'),
    senha: parseXmlTag(xmlResp, 'senha'),
    dataAutorizacao: parseXmlTag(xmlResp, 'dataAutorizacao'),
    dataValidadeSenha: parseXmlTag(xmlResp, 'dataValidadeSenha'),
    statusSolicitacao: parseXmlTag(xmlResp, 'statusSolicitacao'),
    motivos: [],
    servicosAutorizados: [],
  };
  if (xmlResp) {
    const reServ = /<(?:ans:)?servicoAutorizado>([\s\S]*?)<\/(?:ans:)?servicoAutorizado>/gi;
    let ms;
    while ((ms = reServ.exec(xmlResp)) !== null) {
      data.servicosAutorizados.push({
        sequencialItem: parseXmlTag(ms[1], 'sequencialItem'),
        codigo: parseXmlTag(ms[1], 'codigoProcedimento'),
        descricao: parseXmlTag(ms[1], 'descricaoProcedimento'),
        quantidadeSolicitada: parseXmlTag(ms[1], 'quantidadeSolicitada'),
        quantidadeAutorizada: parseXmlTag(ms[1], 'quantidadeAutorizada'),
        valorAutorizado: parseXmlTag(ms[1], 'valorAutorizado'),
      });
    }
    const re = /<(?:ans:)?motivoNegativa>([\s\S]*?)<\/(?:ans:)?motivoNegativa>/gi;
    let m;
    while ((m = re.exec(xmlResp)) !== null) {
      data.motivos.push({
        codigo: parseXmlTag(m[1], 'codigoGlosa'),
        descricao: parseXmlTag(m[1], 'descricaoGlosa'),
      });
    }
    if (data.motivos.length === 0) {
      const re2 = /<(?:ans:)?mensagemErro>([\s\S]*?)<\/(?:ans:)?mensagemErro>/gi;
      let m2;
      while ((m2 = re2.exec(xmlResp)) !== null) {
        data.motivos.push({
          codigo: parseXmlTag(m2[1], 'codigoGlosa'),
          descricao: parseXmlTag(m2[1], 'descricaoGlosa'),
        });
      }
    }
  }
  return data;
}

export function parseTesteConexaoData(xmlReq, xmlResp) {
  return {
    prestador: parseXmlTag(xmlReq, 'codigoPrestadorNaOperadora'),
    cnpj: parseXmlTag(xmlReq, 'CNPJ'),
    registroANS: parseXmlTag(xmlReq, 'registroANS'),
    login: parseXmlTag(xmlReq, 'loginPrestador'),
    resposta: parseXmlTag(xmlResp, 'respostaSolicitacao'),
    conectou: !!xmlResp && !parseXmlTag(xmlResp, 'codigoGlosa'),
    codigoGlosa: parseXmlTag(xmlResp, 'codigoGlosa'),
    descricaoGlosa: parseXmlTag(xmlResp, 'descricaoGlosa'),
  };
}

export function parseStatusGuiaData(xmlReq, xmlResp) {
  const situacaoRaw = parseXmlTag(xmlResp, 'situacao');
  const situacaoMap = { A: 'Autorizado', N: 'Negado', P: 'Pendente', R: 'Rejeitado' };
  const situacaoColorMap = { A: '#2e7d32', N: '#c62828', P: '#e65100', R: '#c62828' };
  const situacaoBgMap = { A: '#e8f5e9', N: '#ffebee', P: '#fff3e0', R: '#ffebee' };
  return {
    protocolo: parseXmlTag(xmlReq, 'numeroProtocolo'),
    prestador: parseXmlTag(xmlReq, 'codigoPrestadorNaOperadora'),
    situacaoRaw,
    situacao: situacaoMap[situacaoRaw] || situacaoRaw || '-',
    situacaoColor: situacaoColorMap[situacaoRaw] || '#999',
    situacaoBg: situacaoBgMap[situacaoRaw] || '#f5f5f5',
    motivoNegativa: parseXmlTag(xmlResp, 'motivoNegativa'),
    descricaoMotivo: parseXmlTag(xmlResp, 'descricaoMotivo') || parseXmlTag(xmlResp, 'descricaoGlosa'),
  };
}

export function parseCancelamentoData(xmlReq, xmlResp) {
  return {
    numeroGuiaPrestador: parseXmlTag(xmlReq, 'numeroGuiaPrestador'),
    tipoGuia: parseXmlTag(xmlReq, 'tipoGuia'),
    prestador: parseXmlTag(xmlReq, 'codigoPrestadorNaOperadora'),
    protocoloRecebimento: parseXmlTag(xmlResp, 'numeroProtocolo'),
    dataRecebimento: parseXmlTag(xmlResp, 'dataRecebimento'),
  };
}

export function parseLoteData(xmlReq, xmlResp) {
  const guiasMatch = xmlReq ? xmlReq.match(/<(?:ans:)?guiaSPSADT/gi) : null;
  return {
    numeroLote: parseXmlTag(xmlReq, 'numeroLote'),
    prestador: parseXmlTag(xmlReq, 'codigoPrestadorNaOperadora'),
    totalGuias: guiasMatch ? guiasMatch.length : 0,
    protocoloRecebimento: parseXmlTag(xmlResp, 'numeroProtocolo'),
    dataRecebimento: parseXmlTag(xmlResp, 'dataRecebimento'),
    horaRecebimento: parseXmlTag(xmlResp, 'horaRecebimento'),
  };
}

export function parseStatusLoteData(xmlReq, xmlResp) {
  const situacaoRaw = parseXmlTag(xmlResp, 'situacao');
  const situacaoMap = { A: 'Aceito', R: 'Rejeitado', P: 'Parcial' };
  const situacaoColorMap = { A: '#2e7d32', R: '#c62828', P: '#e65100' };
  const situacaoBgMap = { A: '#e8f5e9', R: '#ffebee', P: '#fff3e0' };
  return {
    protocolo: parseXmlTag(xmlReq, 'numeroProtocolo'),
    prestador: parseXmlTag(xmlReq, 'codigoPrestadorNaOperadora'),
    situacaoRaw,
    situacao: situacaoMap[situacaoRaw] || situacaoRaw || '-',
    situacaoColor: situacaoColorMap[situacaoRaw] || '#999',
    situacaoBg: situacaoBgMap[situacaoRaw] || '#f5f5f5',
    descricaoMotivo: parseXmlTag(xmlResp, 'descricaoMotivo') || parseXmlTag(xmlResp, 'descricaoGlosa'),
  };
}

export function downloadXml(xml, filename) {
  const blob = new Blob([xml], { type: 'application/xml' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
